// Cómo se lee una tendencia de exactitud · TC-32.
//
// APARTE DE LA PANTALLA para poder probarlo: decidir cuándo NO se dibuja
// una flecha es la regla que sostiene todo este reporte.

/** Qué se le dice a alguien sobre cómo va su exactitud.
 *
 *  SIN HISTORIA NO HAY FLECHA. En un reporte que existe para contestar
 *  «¿voy mejor o peor?», una flecha dibujada con una sola semana de
 *  datos ES TODO EL REPORTE — y sería inventada. El servidor manda nulo
 *  y aquí se dice que falta historia, no «estable».
 *
 *  Y EL UMBRAL NO ES CERO. En una repisa se cuentan pocos renglones, y
 *  medio punto arriba o abajo es ruido. Llamar «mejorando» a eso enseña
 *  a no creerse la palabra el día que signifique algo. */
export function comoVaLaExactitud(tendencia, { umbral = 2 } = {}) {
  if (tendencia === null || tendencia === undefined) {
    return {
      clave: 'sin_historia',
      color: 'gris',
      frase: 'Todavía no hay con qué comparar. Cuenta otra semana.',
    };
  }
  const t = Number(tendencia);
  if (t >= umbral) {
    return {
      clave: 'mejora', color: 'verde',
      frase: `Mejorando: ${t.toFixed(1)} puntos más que antes.`,
    };
  }
  if (t <= -umbral) {
    return {
      clave: 'empeora', color: 'rojo',
      frase: `Empeorando: ${Math.abs(t).toFixed(1)} puntos menos que antes.`,
    };
  }
  return {
    clave: 'estable', color: 'ambar',
    frase: 'Sin cambios apreciables respecto a las semanas anteriores.',
  };
}

/** El color de una exactitud suelta.
 *
 *  LOS CORTES SON LOS DEL OFICIO y no un gusto: 95 % es el mínimo que
 *  pide una auditoría de cliente automotriz, y por debajo de 90 % el
 *  inventario deja de servir para prometer una entrega. */
export function colorDeExactitud(pct) {
  if (pct === null || pct === undefined) return 'gris';
  if (pct >= 95) return 'verde';
  if (pct >= 90) return 'ambar';
  return 'rojo';
}
